import { Box, List, ListItem, makeStyles, Grid, Theme, Typography } from '@material-ui/core';
import axios from 'axios';
import clsx from 'clsx';
import React, { useRef, useEffect, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

import { member as v_member, basic, Values, SNACKBAR_TIME } from '../../../request/values';
import ToastStr from '../../../request/toastStr';
import { TitleBackBar } from '../../../shared/header/TitleBar';
import { COLORS } from '../../../shared/Theme';
import { getTranslatedLicenseName, formatToTimezone } from '../../../locales/formatModule';

const useStyles = makeStyles((theme: Theme) => ({
	wrapper: {
		paddingTop: '10px',
		paddingLeft: '0',
		paddingRight: '0',
		[theme.breakpoints.up('md')]: {
			paddingTop: '50px',
			paddingLeft: '20px',
			paddingRight: '20px',
		},
	},
	itemProcessing: {
		backgroundColor: `${COLORS.LIGHT_GREY}`,
	},
	materialCompanyName: {
		...theme.typography.body1,
		fontWeight: 'bold',
		fontFamily: 'NanumB',
		color: `${COLORS.WATER_BLUE}`,
	},
	titleWrapper: {
		width: '100%',
		textAlign: 'center',
	},
	title: {
		...theme.typography.h1,
		color: `${COLORS.BROWNISH_GREY}`,
		textAlign: 'center',
		[theme.breakpoints.up('md')]: {
			...theme.typography.h4,
		},
	},
	materialItem: {
		borderRadius: 12,
		margin: 'auto',
		marginBottom: '1.5vh',

		boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
		width: '82vw',
		paddingTop: '2.2vh',
		paddingBottom: '2.2vh',
		color: `${COLORS.BROWNISH_GREY}`,
		[theme.breakpoints.up('md')]: {
			width: '60vw',
		},
	},
	list: {
		width: '95vw',
		height: '74.5vh',
		overflowY: 'auto',
		fontFamily: 'NanumB',
		fontWeight: 'bold',
		fontSize: '4vw',
		color: `${COLORS.BROWNISH_GREY}`,
		[theme.breakpoints.up('md')]: {
			width: '62vw',
			height: '100%',
			paddingTop: theme.spacing(1),
			paddingBottom: theme.spacing(6),
		},
	},
	materialImage: {
		textAlign: 'center',
		margin: 'auto',
		paddingRight: '2vw',
		'& img': {
			width: '11vw',
			maxWidth: '80px',
		},
		[theme.breakpoints.up('md')]: {
			'& img': {
				width: '65px',
			},
		},
		[theme.breakpoints.up('lg')]: {
			'& img': {
				width: '55px',
			},
		},
	},
	materialDesc: {
		paddingLeft: '1vw',
		'& #materialSubName': {
			...theme.typography.body1,
			color: `${COLORS.BROWNISH_GREY}`,
		},
	},
	orderStatus: {
		marginTop: '2px',
	},
	orderComplete: {
		color: `${COLORS.WATER_BLUE}`,
		fontFamily: 'NanumB',
		fontWeight: 'bold',
	},
	orderNone: {
		color: `${COLORS.DOWN}`,
		fontFamily: 'NanumB',
		fontWeight: 'bold',
	},

	orderList: {
		width: '100%',
		maxWidth: 360,
	},
	orderSheet: {
		// height : 'calc(100%- 64px)',
		// top: 64
		height: '100vh',
	},
	empty: {
		height: '62vh',
		textAlign: 'center',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		'& img': {
			width: '35vw',
			height: '35vw',
			[theme.breakpoints.up('md')]: {
				width: '25vw',
				height: '25vw',
			},
			marginBottom: '2.5vh',
			opacity: 0.4,
		},
		'& h1': {
			color: `${COLORS.DOWN}`,
		},
	},
	numberWrapper: {
		textAlign: 'right',
		[theme.breakpoints.up('md')]: {
			margin: 'auto',
			textAlign: 'right',
		},
	},
	numberText: {
		...theme.typography.h1,
		color: `${COLORS.BROWNISH_GREY}`,
		fontWeight: 'normal',
		fontFamily: 'NanumR',
		[theme.breakpoints.up('md')]: {
			...theme.typography.h4,
			color: `${COLORS.BROWNISH_GREY}`,
			fontWeight: 'normal',
			fontFamily: 'NanumR',
		},
	},
	paper: {
		padding: theme.spacing(1),
	},
	grid: {
		marginTop: theme.spacing(1),
	},
}));

interface iMaterialList {
	productName: string;
	productImage: string;
	materialOrderNum: number;
	materialStatus: number | null;
	orderCompanyName: string;
}

const MaterialPurchaseList: React.FC<any> = (props) => {
	const classes = useStyles();
	const history = useHistory();
	const { member } = props;
	const { t } = useTranslation('student');
	const [material, setMaterial] = useState<iMaterialList[]>([]);
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();
	const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

	const count = 20;
	let max_count: number = 999;
	const loader = useRef(null);
	const [page, setPage] = useState(-count);

	const handleObserver = useCallback((entries: any) => {
		const target = entries[0];
		if (target.isIntersecting) {
			setPage((prevState) => {
				if (prevState + count > max_count) {
					return prevState;
				}
				return prevState + count;
			});
		}
	}, []);

	const moveMaterialPurchaseSheet = (index: number) => {
		if (index >= 0) {
			history.push({
				pathname: '/MaterialPurchaseSheet/' + material[index].materialOrderNum,
				state: {
					order: material[index],
				},
			});
		}
	};

	const getMaterialOrderAppList = (position: number, count: number) => {
		let url = new URL(basic.server + v_member.member + v_member.material_order_list);
		let params = {
			classCode: member.classCode,
			companyNum: member.companyNum,
			position: position.toString(),
			count: count.toString(),
			classVersion: member.classVersion,
		};
		url.search = new URLSearchParams(params).toString();
		console.log('in');
		axios({
			method: 'GET',
			withCredentials: true,
			url: url.toString(),
		})
			.then((res) => res.data)
			.then((data: any) => {
				if (data.code === Values.SUCCESS_CODE) {
					if (material.length === 0 && data.materials.length === 0) {
						enqueueSnackbar(ToastStr.MATERIAL_ORDER_LIST_EMPTY_STR, {
							variant: 'success',
							autoHideDuration: SNACKBAR_TIME,
						});
					} else if (data.materials === null) {
						enqueueSnackbar(ToastStr.MATERIAL_ORDER_LIST_EMPTY_STR, {
							variant: 'warning',
							autoHideDuration: SNACKBAR_TIME,
						});
					} else {
						console.log(data.materials);
						if (material.length === 0) {
							setMaterial((prevState) => data.materials);
						} else {
							setMaterial((prevState) => prevState.concat(data.materials));
						}
					}
				} else if (data.code === Values.FAIL_CODE) {
					enqueueSnackbar(ToastStr.MATERIAL_ORDER_LIST_FAIL_STR, {
						variant: 'warning',
						autoHideDuration: SNACKBAR_TIME,
					});
				} else if (data.code === Values.EXCEPTION_CODE) {
					enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
						variant: 'error',
						autoHideDuration: SNACKBAR_TIME,
					});
				} else {
					enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, {
						variant: 'error',
						autoHideDuration: SNACKBAR_TIME,
					});
				}
			});
	};

	useEffect(() => {
		const option = {
			root: null,
			rootMargin: '20px',
			threshold: 0,
		};
		const observer = new IntersectionObserver(handleObserver, option);
		if (loader.current) observer.observe(loader.current!);
	}, [handleObserver]);

	useEffect(() => {
		//console.log(page, count)
		if (page >= 0) {
			getMaterialOrderAppList(page, count);
		}
	}, [page]);

	return (
		<div className="content" data-testid="manu-material-purchase-list-dashboard">
			<TitleBackBar history={history} title={t('MaterialPurchaseList.pageTitle')} titleIcon="order" />
			<Box display="grid" justifyContent="center" alignItems="center">
				<Typography className={classes.title} align="center">
					{t('MaterialPurchaseList.pageDesc')}
				</Typography>
				<List className={classes.list}>
					{material.length != 0 ? (
						material.map((item: any, index) => {
							return (
								<ListItem className={item.saleStatus == 'processing' ? clsx(classes.materialItem, classes.itemProcessing) : classes.materialItem} alignItems="center">
									<MaterialItem
										index={index}
										{...item}
										handleClick={(e: any) => {
											moveMaterialPurchaseSheet(index);
										}}
									/>
								</ListItem>
							);
						})
					) : (
						<div className={classes.empty}>
							<div>
								<img src="/images/title/order.webp" />
								<Typography variant="h1">{t('MaterialPurchaseList.empty')}</Typography>
							</div>
						</div>
					)}
					<div ref={loader} />
				</List>
			</Box>
		</div>
	);
};

const MaterialItem: React.FC<any> = (props) => {
	const classes = useStyles();
	const { t } = useTranslation('student');
	const { t: tObject } = useTranslation('object');
	const productName = getTranslatedLicenseName(tObject, props.productName);
	const formattedTimezone = formatToTimezone(props.materialOrderDate);
	const formattedDate = formattedTimezone ? formattedTimezone[0] : '';
	const formattedTime = formattedTimezone ? formattedTimezone[1] : '';

	return (
		<Grid container justify={'center'} alignContent="center" onClick={props.handleClick} data-testid={`manu-material-purchase-list-item-${props.index}`}>
			<Grid xs={2} className={classes.materialImage}>
				<img src={basic.server + '/displayImage?fileName=' + props.productImage} />
			</Grid>
			<Grid xs={8} style={{ margin: 'auto', paddingLeft: '2vw' }}>
				<Grid container direction="column">
					<Grid id="materialName">
						<Typography
							variant="h3"
							style={{
								color: `${COLORS.BROWNISH_GREY}`,
								fontWeight: 'bold',
							}}
						>
							{productName}
							{t('MaterialPurchaseList.productMaterialLabel')}
						</Typography>
					</Grid>
					<Grid id="orderStatus" className={classes.orderStatus}>
						<Typography
							variant="h1"
							className={classes.materialCompanyName}
							style={{
								color: props.materialStatus === -1 ? 'red' : 'inherit',
							}}
						>
							{props.materialStatus >= 1 && props.orderCompanyName + `${t('MaterialPurchaseList.statusComplete')}`}
							{props.materialStatus === -1 && props.orderCompanyName + `${t('MaterialPurchaseList.statusRefuse')}`}
							{props.materialStatus === 0 && `${t('MaterialPurchaseList.statusProcessing')}`}
						</Typography>
					</Grid>
				</Grid>
			</Grid>
			<Grid xs={2} className={classes.numberWrapper}>
				<Typography className={classes.numberText}>{formattedDate}</Typography>
				<Typography className={classes.numberText}>{formattedTime}</Typography>
			</Grid>
		</Grid>
	);
};

export default MaterialPurchaseList;
